module.exports = __webpack_public_path__ + "media/site_templates/www.pest-control.business/images/our_services_3-06d4a11cc5d202b89b5ad559bc8c4252.jpg";